<template>
  <div v-if="!isLoading" class="product-compare-card flex flex-row flex-wrap content-between text-center">
    <div class="w-full">
      <FixedAspect :ratio="0.68">
        <CldnImg
          v-if="imageSrc"
          :src="imageSrc"
          :alt="item.primaryAttribute"
          crop="fit"
          sizes="100vw sm:100vw md:100vw lg:30vw xl:30vw 2xl:347px"
          class="variant-image"
        />
      </FixedAspect>
      <div class="mt-5 w-full">
        <h3 class="fluid-xl leading-none">{{ item.primaryAttribute }}</h3>
        <h4 v-if="item.secondaryAttribute" class="fluid-lg leading-none mt-1 text-br-green">
          {{ item.secondaryAttribute }}
        </h4>
      </div>
    </div>
    <div class="w-full text-copy mt-3 break-words" v-html="description"></div>
    <div class="w-full mt-3">
      <LinkField v-if="item.cta[0] && item.cta[0].url" v-bind="item.cta[0]" class="btn-pill-outline-black" />
    </div>
  </div>
  <div v-else>
    <FixedAspect :ratio="0.55" class="md:mt-3 md:px-5 w-full max-h-full px-2 mt-6 select-none">
      <div class="animated-bg" />
      <Placeholder class="absolute inset-0" />
    </FixedAspect>
    <Placeholder v-for="index in 2" :key="index" class="w-1/2 mx-auto h-6 my-5" />
  </div>
</template>

<script>
import FixedAspect from '@/components/common/FixedAspect';
import Placeholder from '@/components/common/Placeholder';
import LinkField from '@/components/common/LinkField';
import CldnImg from '@/components/CldnImg';

export default defineNuxtComponent({
  name: 'ProductCompareCardSmall',
  components: {
    FixedAspect,
    CldnImg,
    Placeholder,
    LinkField,
  },
  props: {
    item: {
      type: Object,
      default: () => null,
    },
  },
  computed: {
    isLoading() {
      return !this.item;
    },
    description() {
      return this.item?.description;
    },
    cta() {
      return this.item?.cta?.url;
    },
    imageSrc() {
      return this.item?.image?.length && this.item?.image[0]?.url;
    },
  },
});
</script>

<style scoped>
@reference "~/assets/css/main.css";
.variant-image {
  @apply object-contain;
}
</style>
